<template>
  <div class="stay-record" style="min-height: 100vh;">
    <div class="leave_search">
      <!-- 班级选择  -->
      <div class="search_class" @click="classSelectShow = true">
        {{ nowChangeClass.label || '' }}
      </div>
      <!-- 时间选择  -->
      <div class="search_date" @click="handleClickDateOpen">
        {{ showNowDate() }}
      </div>
      <!-- 搜索框 -->
      <div class="search_name">
        <van-dropdown-menu>
          <van-dropdown-item title="" class="no-arrow" ref="item" get-container="#app">
            <template #title>
              <img src="./leave_search.png" alt="">
            </template>

            <!-- 输入搜索内容  -->
            <div class="filter-input">
              <div class="search_input">
                <div class="search-icon">
                  <img src="./search-icon.png" />
                </div>
                <input placeholder="请输入学生姓名" v-model="nowStudentName" />
              </div>

              <div class="search_btn">
                <van-button type="info" class="search_btn_item" round size="small"
                  @click="handleUserSearchLeave">搜索</van-button>
              </div>
            </div>

          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </div>

    <div class="leave_list">
      <div class="list_con">
        <div class="leave_list_item" @click.stop="handleClickOpenStayDetail(item)" v-for="item in stayList"
          :key="item.id" >
          <div class="item_info">
            <div class="info_title">

              <div class="name_date">
                <div class="title_name">
                  {{ item.userName }}
                </div>
                <div class="title_date">
                  {{ getDayDate(item.beginTime) }}留宿
                </div>
              </div>

              <div class="title_status">
                <van-tag style="flex-shrink: 0;" plain type="success" v-if="item.accommodateState == 1">已通过</van-tag>
                <van-tag style="flex-shrink: 0;" plain type="primary" v-if="item.accommodateState == 0">待审批</van-tag>
                <van-tag style="flex-shrink: 0;" plain type="danger" v-if="item.accommodateState == -1">已驳回</van-tag>
                <van-tag style="flex-shrink: 0;" plain type="danger" v-if="item.accommodateState == -2">已过期</van-tag>
                <van-tag style="flex-shrink: 0;" plain type="danger" v-if="item.accommodateState == -3">已作废</van-tag>

              </div>
            </div>
            <div class="info_detail">
              <div class="detail_start">开始时间：{{ getDateYMD(item.beginTime) }}</div>
              <div class="detail_end">结束时间：{{ getDateYMD(item.endTime) }}</div>
              <div class="detail_end">考勤时段：{{ getDormAttendTime(item) }}</div>
              <div class="detail_reason">留宿原因：{{ item.remark }}</div>
            </div>
          </div>
          <!-- 作废处理 -->
          <div class="item_handle" @click.stop="toVoid(item)"
            v-if="item.accommodateState == 1 && isDuringDate(item.endTime) && isAllowToVoid(item)">
            <div class="handle_btn">留宿作废</div>
          </div>
        </div>

      </div>

    </div>



    <!-- 班级选择下拉 -->
    <van-popup v-model="classSelectShow" round position="bottom" get-container="#app">
      <van-picker title="选择班级" :default-index="0" show-toolbar :columns="selectClassList" @confirm="onConfirm"
        @cancel="onCancel" />
    </van-popup>
    <!-- 时间选择下拉 -->
    <van-popup v-model="dateSelectShow" round position="bottom" get-container="#app">
      <van-datetime-picker v-model="defaultDate" title="选择日期" type="date" @confirm="onDateChange" @cancel="onDateCancel"
        swipe-duration="100" />
    </van-popup>

    <!-- 留宿详情 -->
    <stayDetail ref="stayDetailPopRef" @refresh="getStayRecord" />



  </div>
</template>

<script>
import moment from 'moment';
import { compare, getDateYMD, timeFormart } from '@/utils';
// 留宿详情
import stayDetail from './stayDetailPop.vue'
export default {
  components: {
    stayDetail
  },
  name: 'stay-record',
  data() {
    return {
      // 班级下拉选择
      selectClassList: [],
      // 当前选择的班级
      nowChangeClass: {},
      // 当前选择的日期
      nowChangeDate: moment(),
      classSelectShow: false,
      dateSelectShow: false,
      // 当前输入的姓名搜索
      nowStudentName: '',
      schoolId: JSON.parse(localStorage.getItem('userInfo')).schoolId,
      // 默认值
      defaultDate: new Date(),
      stayList: []
    };
  },
  created() {
    this.getTeacherManageClass()
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    isAllowToVoid(data) {
      console.log('data', data)
      if (data.approvals && data.approvals.find(item => item.auditId == this.$store.state.userId)) {
        return true
      } else {
        return false
      }
    },
    onConfirm1() {
      this.$refs.item.toggle();
    },
    getDayDate(date) {
      return moment(date).format('MM月DD日')
    },

    // 判断留宿学生是否能够作废 
    isDuringDate(e) {
      if (moment().isBefore(e)) {
        return true;
      }
      return false;
    },
    // 获取请假详情 
    handleClickOpenStayDetail(data) {
      console.log('点击留宿详情', data)
      this.$refs.stayDetailPopRef.open({
        id: data.id
      })
    },


    // 对当前选中的归寝记录进行作废 
    toVoid(item) {
      // 作废当前请假记录
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: '是否作废该条留宿记录？'
        })
        .then(() => {
          this.toVoidConfirm(item);
        })
        .catch(() => { });
    },

    async toVoidConfirm(item) {
      const { code, data, msg } = await this.$https.dormAccommodateCancel({
        userId: this.$store.state.userId,
        leaveIds: [item.id],
        cancelLeaveInfo: ''
      });

      if (code == 200) {
        this.$toast('操作完成');
        this.getStayRecord();
        return;
      } else {
        this.$toast(msg);
      }
    },



    // 获取考勤时段
    getDormAttendTime(item) {
      let arr = item.attendanceTimeType.split(',')
      let str = ''
      arr.forEach(item => {
        str = str ? str + '，' + ['', '早离寝', '午归寝', '午离寝', '晚归寝'][item] : str + ['', '早离寝', '午归寝', '午离寝', '晚归寝'][item]
      })
      return str
    },
    getDateYMD,
    // 获取当前管理的班级
    async getTeacherManageClass() {
      const { data, code } = await this.$https.getClassListByTeacherId({
        teacherId: this.$store.state.userId
      });
      if (code !== 200) {
        return false;
      }
      let arr = [];
      const fn = (data) => {
        data.forEach(item => {
          if (item.children) {
            fn(item.children)
          } else {
            arr.push(item)
          }
        })
      }
      // 获取所有班级
      fn(data)
      if (arr.length > 1) {
        arr.unshift({
          id: 0,
          label: '全部班级',
          text: '全部班级',
          value: 0
        })
      }

      arr.forEach(item => {
        item.text = item.label
        item.value = item.id
      })
      this.selectClassList = arr;
      this.nowChangeClass = arr[0]
      this.getStayRecord()
    },

    // 姓名搜索
    handleUserSearchLeave() {

      this.getStayRecord()
      this.onConfirm1()
    },
    // 选择班级
    onConfirm(value, index) {
      this.nowChangeClass = value
      this.classSelectShow = false
      this.getStayRecord()
    },
    onCancel() {
      this.classSelectShow = false
    },
    // 选择日期
    onDateChange(value) {
      this.nowChangeDate = moment(value)
      this.dateSelectShow = false
      // 重新获取请假列表
      this.getStayRecord()

    },
    // 取消选择日期
    onDateCancel() {
      this.dateSelectShow = false
    },
    // 点击展开时间选择
    handleClickDateOpen() {
      this.defaultDate = this.nowChangeDate.toDate()
      this.dateSelectShow = true
    },
    // 展示当前选择的时间
    showNowDate() {
      return moment(this.nowChangeDate).format('MM-DD')
    },
    // 获取留宿
    async getStayRecord() {
      const { data, code } = await this.$https.getDormAccommodateListByOrganId({
        date: moment(this.nowChangeDate).format('YYYY-MM-DD'),
        organIds: this.nowChangeClass.id == 0 ? this.selectClassList.filter(item => item.id != 0).map(item => item.id) : [this.nowChangeClass.id],
        schoolId: this.schoolId,
        userName: this.nowStudentName
      });
      if (code != 200) {
        this.stayList = []
        return false
      }
      this.stayList = data
    }
  }
};
</script>

<style lang="scss" scoped>
.stay-record {
  display: flex;
  flex-direction: column;

  .leave_search {
    height: 3.0048rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 0 .7212rem;

    .search_class {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .8413rem;
      color: #000000;
      line-height: 1.1418rem;
      line-height: 0px;
      text-align: left;
      font-style: normal;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        right: -0.7212rem;
        top: 50%;
        transform: translateY(-50%);

        border: .1803rem solid #999;
        border-right-color: transparent;
        border-left-color: transparent;
        border-bottom-color: transparent;
      }
    }

    .search_status {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .8413rem;
      color: #000000;
      line-height: 1.1418rem;
      line-height: 0px;
      text-align: left;
      font-style: normal;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        right: -0.7212rem;
        top: 50%;
        transform: translateY(-50%);

        border: .1803rem solid #999;
        border-right-color: transparent;
        border-left-color: transparent;
        border-bottom-color: transparent;
      }
    }

    .search_date {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .8413rem;
      color: #000000;
      line-height: 1.1418rem;
      line-height: 0px;
      text-align: left;
      font-style: normal;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        right: -0.7212rem;
        top: 50%;
        transform: translateY(-50%);

        border: .1803rem solid #999;
        border-right-color: transparent;
        border-left-color: transparent;
        border-bottom-color: transparent;
      }
    }

    .search_name {
      width: 1.8029rem;
      height: 1.8029rem;
      line-height: 1.8029rem;
      background: #F6F9FC;
      border-radius: 50%;
      text-align: center;

      // 下拉组件样式 


      ::v-deep .van-dropdown-menu .van-dropdown-menu__bar {
        width: 1.8029rem;
        height: 1.8029rem;
        line-height: 1.8029rem;
        box-shadow: none;
        background: #F6F9FC;
        border-radius: 15px 15px 15px 15px;
      }



      ::v-deep .van-dropdown-menu .van-dropdown-menu__bar .van-dropdown-menu__item .van-dropdown-menu__title::after {
        display: none !important;
      }

      img {
        width: .8413rem;
        height: .8413rem;
      }
    }
  }

  .leave_list {
    flex: 1;
    margin: 0 .7212rem;
    position: relative;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0;
    }

    .list_con {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding-bottom: .601rem;

      .leave_list_item {

        margin-top: .601rem;
        background: #FFFFFF;
        border-radius: .2404rem;
        display: flex;
        flex-direction: column;

        .item_info {
          // height: 7.9327rem;
          background: url('./leave_bg.png');
          background-size: 100% 100%;
          padding: 0 .8413rem;

          .info_title {
            display: flex;
            padding: .7813rem 0;
            border-bottom: .0601rem solid #E8E8E8;
            justify-content: space-between;
            align-items: center;

            .name_date {
              display: flex;
              align-items: center;

              .title_name {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: .9615rem;
                color: #000000;
                line-height: 1.262rem;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-right: .8413rem;
              }

              .title_date {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: .8413rem;
                color: #3775FF;
                line-height: 1.1418rem;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }

            .title_status {
              border-radius: .1202rem;
              // border: .0601rem solid #25D81F;
              padding: .1202rem .4207rem;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .7212rem;
              color: #25D81F;
              line-height: .9615rem;
              text-align: left;
              font-style: normal;
            }

          }

          .info_detail {
            padding-bottom: .8413rem;

            .detail_start {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .7212rem;
              color: #999999;
              line-height: .9615rem;
              text-align: left;
              font-style: normal;
              margin-top: .601rem;
            }

            .detail_end {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .7212rem;
              color: #999999;
              line-height: .9615rem;
              text-align: left;
              font-style: normal;
              margin-top: .4808rem;
            }

            .detail_reason {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .7212rem;
              color: #999999;
              line-height: .9615rem;
              text-align: left;
              font-style: normal;
              margin-top: .4808rem;
            }
          }

        }

        .item_handle {
          height: 2.1635rem;
          display: flex;
          justify-content: flex-end;
          padding: 0 .8413rem;

          .handle_btn {
            height: 1.5625rem;
            display: inline-block;
            background-color: rgba(245, 162, 12, .1);
            border-radius: .1202rem;
            padding: 0 .7212rem;
            cursor: pointer;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: .8413rem;
            color: #F5A20C;
            line-height: 1.5625rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }

  }
}

// 姓名搜索
.filter-input {
  display: flex;
  flex: 1;

  // opacity: 0.3;
  overflow: hidden;
  align-items: center;
  margin: 1rem 1rem 1rem 1rem;

  .search_input {
    border-radius: 0.9375rem;
    background-color: #F6F9FC;
    flex: 3;
    display: flex;
    align-items: center;

    .search-icon {
      text-align: center;
      width: 2.125rem;
      flex-shrink: 0;
      padding-top: 0.2rem;
      padding-left: 0.2rem;

      img {
        height: 0.9rem;
      }
    }

    input {
      width: calc(100% - 2.2125rem);
      height: 1.875rem;
      border: 0;
      outline: 0;
      flex: 1;
      padding: 0.4375rem 0;
      font-size: 0.75rem;
      color: #333;
      background: transparent;

      &::placeholder {
        color: #999;
      }
    }
  }

  .search_btn {
    flex: 1;
    margin-left: 1rem;
    background-color: #fff;

    .search_btn_item {
      width: 100%;
    }
  }
}
</style>
